import { BaseQueryApi } from '@reduxjs/toolkit/query'

import { contextMenuApi } from '@redux/api/contextMenu.api'

type Props = {
  contextMenuIds: number[] | undefined
  api: BaseQueryApi
}

export const fetchContextMenuConfigsByIds = async (props: Props) => {
  const { api, contextMenuIds } = props

  const contextMenusPromises =
    contextMenuIds?.map(contextMenuId => {
      return api
        .dispatch(contextMenuApi.endpoints.fetchContextMenuById.initiate(contextMenuId))
        .unwrap()
    }) || []

  const contextMenus = await Promise.all(contextMenusPromises)

  return new Map(contextMenus.map((contextMenu, index) => [contextMenuIds?.[index], contextMenu]))
}
